import { useRef } from "react";
import { NavLink, useLoaderData } from "react-router";
import { hasMobileNavActive, toggleMobileMenu } from "~/utils/menu";
import MobileMenuDropdown from "./mobile-menu-dropdown";
import type { Tag } from "~/models/tag";
import MobileMenuToggle from "./mobile-menu-toggle";
import type { Route } from "../+types/layout";

export default function NavMenu() {
    const initialMenu = useLoaderData<Tag[]>();
    const toggleBtnRef = useRef<HTMLElement | null>(null);

    const toggleMobile = () => {
        const ma = hasMobileNavActive();
        if (ma && toggleBtnRef.current) {
            toggleMobileMenu(toggleBtnRef as React.RefObject<HTMLElement>)
        }
    };
    return (
        <nav id="navmenu" className={'navmenu'}>
            <ul>
                <li><NavLink to='/' onClick={toggleMobile}>Home</NavLink></li>
                <li><NavLink to='/about' onClick={toggleMobile}>About</NavLink></li>
                <li className="dropdown"><NavLink to="/courses" onClick={toggleMobile}><span>Courses</span> <MobileMenuDropdown /></NavLink>
                    <ul>
                        {initialMenu.map((item) => (
                            <li key={item.id}>
                                <NavLink to={`/courses/${item.reference}`} onClick={toggleMobile}>{item.name}</NavLink>
                            </li>
                        ))}
                    </ul>
                </li>
                <li><NavLink to='/online-training' onClick={toggleMobile}>Online Training</NavLink></li>
                <li className="dropdown"><a href='https://blog.constellationtraining.co.uk/' onClick={toggleMobile}><span>Blog</span>  <MobileMenuDropdown /></a>
                    <ul>
                        <li><a href='https://blog.constellationtraining.co.uk/' onClick={toggleMobile}>All Posts</a></li>
                        <li><a href='https://blog.constellationtraining.co.uk/tag/first-aid/' onClick={toggleMobile}>First Aid</a></li>
                        <li><a href='https://blog.constellationtraining.co.uk/tag/mental-health-first-aid/' onClick={toggleMobile}>Mental Health First Aid</a></li>
                        <li><a href='https://blog.constellationtraining.co.uk/tag/workplace-stress/' onClick={toggleMobile}>Workplace Stress</a></li>
                    </ul>
                </li>
                <li><NavLink to='/contact' onClick={toggleMobile}>Contact Us</NavLink></li>
            </ul>
            <MobileMenuToggle ref={toggleBtnRef} />
        </nav>
    );
}